import { useState } from "react";

const today = new Date().toISOString().split('T')[0];

const FontImport = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@400;500;600;700&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { background: #F7F6F3; }
    input[type=range] { accent-color: #c99e66; width: 100%; }
    .hov-card { transition: all 0.2s ease; }
    .hov-card:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.09) !important; }
    .tab-btn:hover { background: #F0EDE6 !important; }
    .ghost-btn:hover { background: #f0f0f0 !important; }
    ::-webkit-scrollbar { width: 5px; height: 5px; }
    ::-webkit-scrollbar-track { background: transparent; }
    ::-webkit-scrollbar-thumb { background: #ddd; border-radius: 10px; }
  `}</style>
);

// ── DATA ──────────────────────────────────────────────────────────────────────
const USERS = {
  "sharma.travels": { password: "ST@2026",  name: "Rajesh Sharma", company: "Sharma Travels", category: "A", points: 12400, tier: "Gold",   bookings: 48, city: "Delhi" },
  "infosys.corp":   { password: "INF@2026", name: "Priya Mehta",   company: "Infosys Ltd",    category: "B", points: 6800,  tier: "Silver", bookings: 23, city: "Bangalore" },
  "verma.tours":    { password: "VT@2026",  name: "Anand Verma",   company: "Verma Tours",    category: "C", points: 2100,  tier: "Bronze", bookings: 9,  city: "Mumbai" },
};

const HOTELS = [
  {
    "id": "h1",
    "name": "Amritara Chakra River Resort, Rishikesh, Uttarakhand",
    "city": "Rishikesh",
    "stars": 5,
    "img": "🏔️",
    "tagline": "Heritage luxury in the Himalayas",
    "amenities": [
      "Infinity Pool",
      "Spa & Wellness",
      "Mountain View Restaurant",
      "Conference Hall",
      "Valet Parking",
      "24h Butler"
    ],
    "experiences": [
      "Sunrise Trek",
      "Heritage Walk",
      "Apple Orchard Tour",
      "Bonfire Evenings"
    ]
  },
  {
    "id": "h2",
    "name": "Amritara Surya - A Luxury Spa Resort, Mcleod Ganj",
    "city": "Mcleod Ganj",
    "stars": 5,
    "img": "🏙️",
    "tagline": "Discover the pinnacle of luxury and serenity at Amritara Surya",
    "amenities": [
      "Rooftop Pool",
      "Citrus Café",
      "Business Centre",
      "Gym & Spa",
      "Airport Shuttle",
      "EV Charging"
    ],
    "experiences": [
      "City Food Tour",
      "Golf Nearby",
      "Yoga at Dawn"
    ]
  },
  {
    "id": "h3",
    "name": "Amritara A Beach Symphony, Mararikulam",
    "city": "Mararikulam",
    "stars": 4,
    "img": "🌿",
    "tagline": "Urban retreat amid garden city serenity",
    "amenities": [
      "Garden Pool",
      "Orchid Restaurant",
      "Rooftop Bar",
      "Spa",
      "Co-working Space",
      "Concierge"
    ],
    "experiences": [
      "Brewery Tour",
      "Craft Market",
      "Nandi Hills Drive",
      "Garden Yoga"
    ]
  },
  
];

const ROOMS = {
  h1: [
  {
    "id": "r1",
    "hotelId": "h1",
    "name": "Executive Room With Balcony",
    "view": "Valley View",
    "size": "32 sqm",
    "price": 6500,
    "available": 10,
    "img": "🏔️",
    "desc": "Experience refined comfort in our 15 Executive Rooms, blending contemporary elegance with stunning outdoor views. Choose from 10 rooms that open directly to the lawn and patio facing the pool, or 5 rooms that provide balcony access with mountain vistas. Spanning 279 sq. ft. and offering a king bed, this category comfortably hosts up to 3 adults and 1 child, perfect for guests seeking a premium yet peaceful stay.",
    "amenities": [
      "King Bed",
      "Balcony",
      "Mountain View",
      "Rain Shower",
      "Mini Bar",
      "Smart TV",
      "Free WiFi",
      "Bathrobe"
    ],
    "images": [
      "🌅 Mountain Sunrise View",
      "🛏️ King Bed with Himalayan Backdrop",
      "🚿 Rain Shower Suite"
    ]
  },
  {
    "id": "r2",
    "hotelId": "h1",
    "name": " Family Room With Balcony",
    "view": " Valley View",
    "size": "54 sqm",
    "price": 7000,
    "available": 4,
    "img": "🛋️",
    "desc": "Colonial-era architecture meets modern luxury. Antique furniture, a sit-out lounge and butler service.",
    "amenities": [
      "King Bed",
      "Living Room",
      "Butler Service",
      "Claw-foot Tub",
      "Valley View",
      "Fireplace",
      "Espresso Machine",
      "Premium Minibar"
    ],
    "images": [
      "🏛️ Colonial Living Room",
      "🛁 Claw-foot Bathtub",
      "🌄 Private Valley Terrace"
    ]
  },
  {
    "id": "r3",
    "hotelId": "h1",
    "name": "Premium Room",
    "view": "Valley View",
    "size": "90 sqm",
    "price": 10000,
    "available": 2,
    "img": "🏡",
    "desc": "Indulge in contemporary style in our 10 Premium Rooms With Balcony &amp; Valley View, offering a perfect balance of space and comfort. Featuring a king bed, sofa-cum-bed and 339 sq. ft. of room to unwind, they accommodate up to 3 adults and 2 children with ease. Select from 6 rooms that connect you to the outdoors with lawn and patio access or 4 rooms with serene balcony views of the mountains, inviting relaxation your way.",
    "amenities": [
      "Private Plunge Pool",
      "Outdoor Firepit",
      "2 Bedrooms",
      "Full Kitchen",
      "Personal Chef",
      "Forest View",
      "Home Theatre",
      "Jacuzzi"
    ],
    "images": [
      "🌲 Forest Villa Exterior",
      "🏊 Private Plunge Pool",
      "🎬 Home Theatre Lounge"
    ]
  }
],
  h2: [
  {
    "id": "r4",
    "hotelId": "h2",
    "name": "Superior Room",
    "view": "City View",
    "size": "28 sqm",
    "price": 5200,
    "available": 15,
    "img": "🌆",
    "desc": "Experience an elevated stay in our spacious Superior Rooms. Each room spans a generous 318 sq. ft., offering ample space for your comfort. Enjoy the captivating view of Mall Road. Our Superior Rooms are thoughtfully equipped with a range of amenities, including high-speed Wi-Fi, complimentary water bottles, a wardrobe, bathrobe and bath slippers, a hairdryer, and more. With an open window allowing natural light to fill the room, you'll find everything you need for a delightful and relaxing stay.",
    "amenities": [
      "Queen Bed",
      "Work Desk",
      "City View",
      "Fast WiFi",
      "Smart TV",
      "Coffee Maker",
      "In-room Safe",
      "Blackout Curtains"
    ],
    "images": [
      "🌃 City Night View",
      "💼 Business Work Zone",
      "☕ Coffee Corner"
    ]
  },
  {
    "id": "r5",
    "hotelId": "h2",
    "name": "Standard Room",
    "view": "Mall Road View",
    "size": "48 sqm",
    "price": 9800,
    "available": 6,
    "img": "💼",
    "desc": "Discover the epitome of comfort in ours. These 242 sq. ft spaces offer modern amenities, including a 32-inch TV, with the added delight of a picturesque Mall Road View. Relax in a soundproof environment and unwind in the cozy sitting area with a sofa chair, ensuring a peaceful and comfortable stay.",
    "amenities": [
      "King Bed",
      "Executive Lounge",
      "Living Room",
      "Skyline View",
      "Premium Bar",
      "Nespresso",
      "Bathtub",
      "Late Checkout"
    ],
    "images": [
      "🌇 Skyline Suite View",
      "🍸 Executive Lounge",
      "🛁 Luxury Bathroom"
    ]
  }
],
  h3: [
  {
    "id": "r6",
    "hotelId": "h3",
    "name": "Garden View Villa",
    "view": "Garden View",
    "size": "30 sqm",
    "price": 4800,
    "available": 12,
    "img": "🌿",
    "desc": "Step into the calm Garden View Villa - SITAR Cottage. It has two beds and a big space of 1056 sq. ft. The shower is private, and the beach is just 200 meters away. You'll have AC, hot/cold water, and a working desk. If you want, you can upgrade to the Pool Villa Cottage for a private pool or jacuzzi.",
    "amenities": [
      "Queen Bed",
      "Garden View",
      "Balcony",
      "Yoga Mat",
      "Organic Toiletries",
      "Smart TV",
      "WiFi",
      "Tea & Coffee"
    ],
    "images": [
      "🌺 Garden View Balcony",
      "🎨 Curated Art Room",
      "🧘 Wellness Corner"
    ]
  },
  {
    "id": "r8",
    "hotelId": "h3",
    "name": "2 Bedroom Villa (KHOMBU Cottage)",
    "view": "Villa View",
    "size": "60 sqm",
    "price": 11500,
    "available": 3,
    "img": "🌸",
    "desc": "Experience luxury in the 2 Bedroom Villa - KHOMBU Cottage. It's right on the beach and has a lot of space. It fits 4 adults and 1 child. You'll have AC, hot water, and a place to work. If you want, you can choose to make it even fancier.",
    "amenities": [
      "King Bed",
      "Pool View Terrace",
      "Deep Soaking Tub",
      "Butler Service",
      "Living Area",
      "Orchid Amenity",
      "Premium Minibar",
      "Pillow Menu"
    ],
    "images": [
      "🌸 Orchid Suite Terrace",
      "🛁 Soaking Tub with Garden View",
      "🌿 Curated Living Area"
    ]
  },
  {
    "id": "r7",
    "hotelId": "h3",
    "name": "Villa with Private Garden",
    "view": "Private Garden",
    "size": "60 sqm",
    "price": 11500,
    "available": 3,
    "img": "🌸",
    "desc": "Feel Kerala's charm in the Beach Villa - NAGASWARAM Cottage. There's a big cozy bed, a garden just for you, and AC to keep you comfy. It's very close to the beach, just 200 meters away. You can book it online for a nice beach holiday.",
    "amenities": [
      "King Bed",
      "Pool View Terrace",
      "Deep Soaking Tub",
      "Butler Service",
      "Living Area",
      "Orchid Amenity",
      "Premium Minibar",
      "Pillow Menu"
    ],
    "images": [
      "🌸 Orchid Suite Terrace",
      "🛁 Soaking Tub with Garden View",
      "🌿 Curated Living Area"
    ]
  }
],
};

const TA_DATA = [
  { id:"TA001", name:"Rajesh Sharma",  company:"Sharma Travels",  city:"Delhi",      cat:"A", bookings:48, revenue:216000, points:12400, lastVisit:"12 May 2026", status:"Active",  trend:"up" },
  { id:"TA002", name:"Sunita Kapoor",  company:"Kapoor Holidays", city:"Chandigarh", cat:"A", bookings:41, revenue:184500, points:10250, lastVisit:"8 May 2026",  status:"Active",  trend:"up" },
  { id:"TA003", name:"Priya Mehta",    company:"Infosys Ltd",     city:"Bangalore",  cat:"B", bookings:23, revenue:103500, points:6800,  lastVisit:"2 May 2026",  status:"Active",  trend:"stable" },
  { id:"TA004", name:"Anand Verma",    company:"Verma Tours",     city:"Mumbai",     cat:"C", bookings:9,  revenue:40500,  points:2100,  lastVisit:"18 Apr 2026", status:"Dormant", trend:"down" },
  { id:"TA005", name:"Kavita Singh",   company:"Singh Travels",   city:"Jaipur",     cat:"B", bookings:17, revenue:76500,  points:4250,  lastVisit:"5 May 2026",  status:"Active",  trend:"up" },
  { id:"TA006", name:"Mohan Das",      company:"Das & Co",        city:"Hyderabad",  cat:"C", bookings:4,  revenue:18000,  points:900,   lastVisit:"1 Mar 2026",  status:"Dormant", trend:"down" },
  { id:"TA007", name:"Deepak Jain",    company:"Jain Travels",    city:"Pune",       cat:"A", bookings:36, revenue:162000, points:9000,  lastVisit:"15 May 2026", status:"Active",  trend:"stable" },
];

const TRANSACTIONS = [
  { date:"15 May 2026", desc:"3× Executive Room With Balcony · Amritara Chakra River Resort, Rishikesh, Uttarakhand",      amount:39000,  points:"+975",  type:"earn" },
  { date:"10 May 2026", desc:"1× Superior Room · Amritara Surya - A Luxury Spa Resort, Mcleod Ganj",         amount:56000,  points:"+1400", type:"earn" },
  { date:"5 May 2026",  desc:"Garden View Villa · Amritara A Beach Symphony, Mararikulam",    amount:-5000,  points:"-500",  type:"redeem" },
];

// ── THEME ─────────────────────────────────────────────────────────────────────
const C = { bg:"#F7F6F3", white:"#FFFFFF", gold:"#c99e66", goldLight:"#F5EDD6", dark:"#813626", text:"#3A3A3A", muted:"#8A8A8A", border:"#E8E5DF", green:"#2D8A4E", red:"#813626", blue:"#1A6FA8", silver:"#8E8E93", bronze:"#CD7F32", cream:"#FAF8F4" };
const serif = "'Cormorant Garamond', Georgia, serif";
const sans  = "'DM Sans', sans-serif";

// ── SHARED COMPONENTS ─────────────────────────────────────────────────────────
const catStyle = { A:{ bg:"#FFF3CD", color:"#7A5C00" }, B:{ bg:"#D6EAF8", color:"#0C4A6E" }, C:{ bg:"#FDECEA", color:"#813626" } };
function Badge({ cat }) {
  const s = catStyle[cat] || catStyle.C;
  return <span style={{ background:s.bg, color:s.color, padding:"3px 12px", borderRadius:20, fontSize:11, fontWeight:700, letterSpacing:0.6, fontFamily:sans }}>Cat {cat} · {cat==="A"?"Gold":cat==="B"?"Silver":"Bronze"}</span>;
}
function StatCard({ label, value, sub, accent }) {
  return (
    <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:14, padding:"18px 22px", flex:1, minWidth:130 }}>
      <div style={{ fontSize:11, color:C.muted, fontWeight:700, letterSpacing:1, textTransform:"uppercase", marginBottom:8, fontFamily:sans }}>{label}</div>
      <div style={{ fontSize:26, fontWeight:700, color:accent||C.dark, fontFamily:serif, lineHeight:1 }}>{value}</div>
      {sub && <div style={{ fontSize:12, color:C.muted, marginTop:5, fontFamily:sans }}>{sub}</div>}
    </div>
  );
}
function Inp({ label, value, onChange, placeholder, type="text" }) {
  return (
    <div>
      <label style={{ fontSize:11, fontWeight:700, letterSpacing:0.9, color:C.muted, display:"block", marginBottom:5, fontFamily:sans, textTransform:"uppercase" }}>{label}</label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{ width:"100%", padding:"10px 13px", border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:14, outline:"none", background:C.white, fontFamily:sans, color:C.dark }} />
    </div>
  );
}

// ── ROOM DETAIL MODAL ─────────────────────────────────────────────────────────
function RoomModal({ room, hotel, nights, qty, onClose, onAdd }) {
  const [q, setQ] = useState(qty || 0);
  if (!room || !hotel) return null;
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }} onClick={onClose}>
      <div style={{ background:C.white, borderRadius:20, maxWidth:660, width:"100%", maxHeight:"90vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
        <div style={{ background:"linear-gradient(135deg,#813626,#813626)", borderRadius:"20px 20px 0 0", padding:"28px 30px 22px", color:"#fff", position:"relative" }}>
          <button onClick={onClose} style={{ position:"absolute", top:14, right:18, background:"rgba(255,255,255,0.15)", border:"none", color:"#fff", borderRadius:"50%", width:30, height:30, fontSize:17, cursor:"pointer" }}>×</button>
          <div style={{ fontSize:30, marginBottom:8 }}>{room.img}</div>
          <div style={{ fontSize:26, fontWeight:700, fontFamily:serif, marginBottom:3 }}>{room.name}</div>
          <div style={{ fontSize:13, color:"rgba(255,255,255,0.55)", fontFamily:sans }}>{hotel.name} · {room.view} · {room.size}</div>
          <div style={{ marginTop:12, fontSize:22, fontWeight:700, color:C.gold, fontFamily:serif }}>₹{room.price.toLocaleString()} <span style={{ fontSize:13, color:"rgba(255,255,255,0.45)", fontFamily:sans }}>/ night</span></div>
        </div>
        <div style={{ padding:"22px 30px" }}>
          <p style={{ fontSize:14, color:C.text, lineHeight:1.7, fontFamily:sans, marginBottom:20 }}>{room.desc}</p>
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:12, fontWeight:700, letterSpacing:0.9, color:C.muted, marginBottom:10, fontFamily:sans, textTransform:"uppercase" }}>Gallery</div>
            <div style={{ display:"flex", gap:8 }}>
              {room.images.map((img,i)=>(
                <div key={i} style={{ flex:1, background:"linear-gradient(135deg,#F5EDD6,#EDE0C8)", borderRadius:10, padding:"16px 10px", textAlign:"center", fontSize:12, color:"#7A5C00", fontWeight:600, fontFamily:sans, lineHeight:1.5 }}>{img}</div>
              ))}
            </div>
          </div>
          <div style={{ marginBottom:22 }}>
            <div style={{ fontSize:12, fontWeight:700, letterSpacing:0.9, color:C.muted, marginBottom:10, fontFamily:sans, textTransform:"uppercase" }}>Amenities</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:7 }}>
              {room.amenities.map((a,i)=>(
                <span key={i} style={{ padding:"5px 12px", background:C.cream, border:`1px solid ${C.border}`, borderRadius:20, fontSize:12, color:C.text, fontFamily:sans }}>✓ {a}</span>
              ))}
            </div>
          </div>
          <div style={{ background:C.cream, borderRadius:12, padding:18, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>Add to Cart</div>
              <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{room.available} rooms available · {nights} night{nights>1?"s":""}</div>
            </div>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <button onClick={()=>setQ(q=>Math.max(0,q-1))} style={{ width:32, height:32, borderRadius:"50%", border:`1.5px solid ${C.border}`, background:C.white, cursor:"pointer", fontSize:18, display:"flex", alignItems:"center", justifyContent:"center" }}>−</button>
              <span style={{ fontSize:18, fontWeight:700, fontFamily:sans, minWidth:26, textAlign:"center" }}>{q}</span>
              <button onClick={()=>setQ(q=>Math.min(room.available,q+1))} style={{ width:32, height:32, borderRadius:"50%", border:`1.5px solid ${C.border}`, background:C.white, cursor:"pointer", fontSize:18, display:"flex", alignItems:"center", justifyContent:"center" }}>+</button>
              <button onClick={()=>{ onAdd(room, q); onClose(); }}
                style={{ padding:"9px 20px", background:C.dark, color:"#fff", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:sans }}>
                {q===0?"Remove":"Add →"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── CART ITEM (room line in sidebar) ─────────────────────────────────────────
// cartItems = [{ key, hotelId, hotelName, hotelImg, roomId, roomName, roomImg, roomPrice, checkin, checkout, nights, qty }]

// ── BOOKING MODULE ────────────────────────────────────────────────────────────
function BookingModule({ user }) {
  // ─ State
  const [step, setStep]               = useState(1); // 1=Browse 2=Guests 3=Confirm
  const [activeHotel, setActiveHotel] = useState(HOTELS[0]);
  const getFormattedDate = (date) => date.toLocaleDateString('en-CA');

// Define your default initial dates
const todayObj = new Date();
const tomorrowObj = new Date();
tomorrowObj.setDate(todayObj.getDate() + 3); // Sets checkout to 3 days after check-in

const todayStr = getFormattedDate(todayObj);       // e.g., "2026-05-29"
const checkoutStr = getFormattedDate(tomorrowObj); // e.g., "2026-06-01"

// inside your component:
const [checkin, setCheckin]   = useState(todayStr);
const [checkout, setCheckout] = useState(checkoutStr);
  const [cart, setCart]               = useState([]); // array of cart items
  const [modalRoom, setModalRoom]     = useState(null);
  const [expandedHotel, setExpandedHotel] = useState(null);

  const [hci, setHci] = useState(checkin);
              const [hco, setHco] = useState(checkout);

  // Guest allocation: one entry per cart slot
  // slot = { slotId, hotelName, hotelImg, roomName, roomImg, checkin, checkout, name, email, phone }
  const [bookingType, setBookingType] = useState(null);
  const [primaryGuest, setPrimaryGuest] = useState({ name:"", email:"", phone:"", company:"" });
  const [slots, setSlots]             = useState([]);
  const [confirmed, setConfirmed]     = useState(false);

  const nights = (ci, co) => Math.max(1, (new Date(co)-new Date(ci))/86400000);
  const cartNights = (item) => nights(item.checkin, item.checkout);

  const totalRooms = cart.reduce((s,i)=>s+i.qty, 0);
  const totalAmt   = cart.reduce((s,i)=>s+i.qty*i.roomPrice*cartNights(i), 0);
  const pointsEarn = Math.floor(totalAmt*0.025);

  // Add/update room in cart
  const addToCart = (room, qty, hotel, ci, co) => {
    const key = `${room.id}__${ci}__${co}`;
    setCart(prev => {
      const exists = prev.find(i=>i.key===key);
      if (qty===0) return prev.filter(i=>i.key!==key);
      if (exists)  return prev.map(i=>i.key===key ? {...i, qty} : i);
      return [...prev, { key, hotelId:hotel.id, hotelName:hotel.name, hotelImg:hotel.img, roomId:room.id, roomName:room.name, roomImg:room.img, roomPrice:room.price, checkin:ci, checkout:co, nights:nights(ci,co), qty }];
    });
  };

  const removeFromCart = (key) => setCart(prev=>prev.filter(i=>i.key!==key));

  const cartQty = (roomId, ci, co) => {
    const key = `${roomId}__${ci}__${co}`;
    return cart.find(i=>i.key===key)?.qty || 0;
  };

  // Build guest slots from cart
  const buildSlots = () => {
    const s = [];
    cart.forEach(item => {
      for (let i=0; i<item.qty; i++) {
        s.push({ slotId:`${item.key}_${i}`, hotelName:item.hotelName, hotelImg:item.hotelImg, roomName:item.roomName, roomImg:item.roomImg, checkin:item.checkin, checkout:item.checkout, name:"", email:"", phone:"" });
      }
    });
    setSlots(s);
  };

  const updateSlot = (slotId, field, val) => setSlots(prev=>prev.map(s=>s.slotId===slotId?{...s,[field]:val}:s));
  const copyPrimaryToAll = () => setSlots(prev=>prev.map(s=>({...s, name:primaryGuest.name, email:primaryGuest.email, phone:primaryGuest.phone})));

  const resetAll = () => { setStep(1); setCart([]); setBookingType(null); setPrimaryGuest({name:"",email:"",phone:"",company:""}); setSlots([]); setConfirmed(false); };

  // ─ Confirmed screen
  if (confirmed) return (
    <div style={{ textAlign:"center", padding:"60px 20px" }}>
      <div style={{ fontSize:64, marginBottom:16 }}>🎉</div>
      <div style={{ fontSize:30, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:10 }}>Booking Confirmed!</div>
      <div style={{ fontSize:14, color:C.muted, fontFamily:sans, marginBottom:6 }}>Ref: <strong style={{color:C.dark}}>CIN-{Math.random().toString(36).substring(2,8).toUpperCase()}</strong></div>
      <div style={{ fontSize:15, color:C.green, fontWeight:700, fontFamily:sans, marginBottom:6 }}>+{pointsEarn.toLocaleString()} loyalty points earned!</div>
      <div style={{ fontSize:13, color:C.muted, fontFamily:sans, marginBottom:32 }}>{totalRooms} room{totalRooms>1?"s":""} across {[...new Set(cart.map(i=>i.hotelId))].length} propert{[...new Set(cart.map(i=>i.hotelId))].length>1?"ies":"y"}</div>
      <button onClick={resetAll} style={{ padding:"13px 30px", background:C.dark, color:"#fff", border:"none", borderRadius:12, fontSize:15, cursor:"pointer", fontFamily:sans, fontWeight:700 }}>New Booking</button>
    </div>
  );

  // ─ Step indicator
  const STEPS = ["Browse & Add to Cart","Guest Details","Review & Confirm"];

  return (
    <div>
      {/* Room detail modal */}
      {modalRoom && (
        <RoomModal room={modalRoom.room} hotel={modalRoom.hotel} nights={nights(checkin,checkout)}
          qty={cartQty(modalRoom.room.id, checkin, checkout)}
          onClose={()=>setModalRoom(null)}
          onAdd={(room, qty)=>addToCart(room, qty, modalRoom.hotel, checkin, checkout)} />
      )}

      <div style={{ fontSize:22, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:4 }}>Multi-Property Booking</div>
      <div style={{ fontSize:13, color:C.muted, fontFamily:sans, marginBottom:22 }}>Select rooms from one or more hotels. Every booking earns loyalty points.</div>

      {/* Step bar */}
      <div style={{ display:"flex", alignItems:"center", marginBottom:28 }}>
        {STEPS.map((s,i)=>(
          <div key={i} style={{ display:"flex", alignItems:"center", flex:1 }}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", flex:1 }}>
              <div style={{ width:30, height:30, borderRadius:"50%", background:step>i+1?C.green:step===i+1?C.dark:C.border, color:step>=i+1?"#fff":C.muted, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, fontFamily:sans, marginBottom:5 }}>
                {step>i+1?"✓":i+1}
              </div>
              <div style={{ fontSize:11, color:step===i+1?C.dark:C.muted, fontWeight:step===i+1?700:500, fontFamily:sans, textAlign:"center" }}>{s}</div>
            </div>
            {i<STEPS.length-1 && <div style={{ height:2, flex:0.4, background:step>i+1?C.green:C.border, marginBottom:18 }} />}
          </div>
        ))}
      </div>

      {/* ─────── STEP 1: Browse ─────── */}
      {step===1 && (
        <div style={{ display:"flex", gap:22 }}>
          {/* Left: hotel + room browser */}
          <div style={{ flex:1, minWidth:0 }}>
            {/* Global dates */}
            <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:14, padding:"16px 20px", marginBottom:18, display:"flex", gap:16, alignItems:"flex-end", flexWrap:"wrap" }}>
              <div style={{ flex:1, minWidth:130 }}>
                <label style={{ fontSize:11, fontWeight:700, letterSpacing:0.9, color:C.muted, display:"block", marginBottom:6, fontFamily:sans, textTransform:"uppercase" }}>Default Check-In</label>
                <input 
                    type="date" 
                    value={checkin} 
                    min={today} // This line disables all dates before today
                    onChange={e => setCheckin(e.target.value)} 
                    style={{ 
                      width: "100%", 
                      padding: "10px 13px", 
                      border: `1.5px solid ${C.border}`, 
                      borderRadius: 9, 
                      fontSize: 14, 
                      outline: "none", 
                      background: C.white, 
                      fontFamily: sans 
                    }} 
                  />
              </div>
              <div style={{ flex:1, minWidth:130 }}>
                <label style={{ fontSize:11, fontWeight:700, letterSpacing:0.9, color:C.muted, display:"block", marginBottom:6, fontFamily:sans, textTransform:"uppercase" }}>Default Check-Out</label>
                <input type="date" value={checkout} onChange={e=>setCheckout(e.target.value)} style={{ width:"100%", padding:"10px 13px", border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:14, outline:"none", background:C.white, fontFamily:sans }} />
              </div>
              <div style={{ padding:"10px 16px", background:C.goldLight, borderRadius:9, fontSize:13, fontWeight:700, color:C.gold, fontFamily:sans, whiteSpace:"nowrap" }}>{nights(checkin,checkout)} Night{nights(checkin,checkout)>1?"s":""}</div>
              <div style={{ fontSize:12, color:C.muted, fontFamily:sans, alignSelf:"center" }}>Dates can be customised per hotel below</div>
            </div>

            {/* Hotels accordion */}
            {HOTELS.map(hotel => {
              const hotelRooms = ROOMS[hotel.id] || [];
              const hotelInCart = cart.filter(i=>i.hotelId===hotel.id);
              const hotelCartRooms = hotelInCart.reduce((s,i)=>s+i.qty,0);
              const open = expandedHotel===hotel.id;

              // Per-hotel date overrides
              

              return (
                <div key={hotel.id} style={{ background:C.white, border:`2px solid ${hotelCartRooms>0?C.gold:C.border}`, borderRadius:16, marginBottom:14, overflow:"hidden", boxShadow:hotelCartRooms>0?`0 0 0 3px ${C.goldLight}`:"none" }}>
                  {/* Hotel header row */}
                  <div style={{ padding:"16px 20px", display:"flex", alignItems:"center", gap:14, cursor:"pointer" }} onClick={()=>setExpandedHotel(open?null:hotel.id)}>
                    <div style={{ fontSize:28, flexShrink:0 }}>{hotel.img}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <div style={{ fontSize:16, fontWeight:700, fontFamily:serif, color:C.dark }}>{hotel.name}</div>
                        {hotelCartRooms>0 && <span style={{ background:C.gold, color:"#fff", borderRadius:20, padding:"2px 10px", fontSize:11, fontWeight:700, fontFamily:sans }}>{hotelCartRooms} room{hotelCartRooms>1?"s":""} in cart</span>}
                      </div>
                      <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{hotel.city} · {"⭐".repeat(hotel.stars)} · {hotel.tagline}</div>
                    </div>
                    <div style={{ fontSize:18, color:C.muted, transform:open?"rotate(180deg)":"none", transition:"transform 0.2s" }}>⌄</div>
                  </div>

                  {/* Expanded content */}
                  {open && (
                    <div style={{ borderTop:`1px solid ${C.border}` }}>
                      {/* Amenities + Experiences */}
                      <div style={{ padding:"14px 20px", background:C.cream, display:"flex", gap:24 }}>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:11, fontWeight:700, letterSpacing:0.9, color:C.muted, marginBottom:8, fontFamily:sans, textTransform:"uppercase" }}>Amenities</div>
                          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                            {hotel.amenities.map((a,i)=><span key={i} style={{ fontSize:11, background:C.white, border:`1px solid ${C.border}`, borderRadius:20, padding:"3px 10px", color:C.muted, fontFamily:sans }}>✓ {a}</span>)}
                          </div>
                        </div>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:11, fontWeight:700, letterSpacing:0.9, color:C.muted, marginBottom:8, fontFamily:sans, textTransform:"uppercase" }}>Experiences</div>
                          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                            {hotel.experiences.map((e,i)=><span key={i} style={{ fontSize:11, background:C.white, border:`1px solid ${C.border}`, borderRadius:20, padding:"3px 10px", color:C.muted, fontFamily:sans }}>🌟 {e}</span>)}
                          </div>
                        </div>
                      </div>

                      {/* Per-hotel date override */}
                      <div style={{ padding:"12px 20px", borderTop:`1px solid ${C.border}`, display:"flex", gap:14, alignItems:"flex-end", background:"#fff" }}>
                        <div style={{ fontSize:12, color:C.muted, fontFamily:sans, alignSelf:"center", marginRight:4 }}>Dates for this hotel:</div>
                        <div>
                          <label style={{ fontSize:10, fontWeight:700, color:C.muted, display:"block", marginBottom:4, fontFamily:sans, textTransform:"uppercase" }}>Check-In</label>
                          <input type="date" value={hci} onChange={e=>setHci(e.target.value)} style={{ padding:"8px 11px", border:`1.5px solid ${C.border}`, borderRadius:8, fontSize:13, outline:"none", fontFamily:sans }} />
                        </div>
                        <div>
                          <label style={{ fontSize:10, fontWeight:700, color:C.muted, display:"block", marginBottom:4, fontFamily:sans, textTransform:"uppercase" }}>Check-Out</label>
                          <input type="date" value={hco} onChange={e=>setHco(e.target.value)} style={{ padding:"8px 11px", border:`1.5px solid ${C.border}`, borderRadius:8, fontSize:13, outline:"none", fontFamily:sans }} />
                        </div>
                        <div style={{ padding:"8px 14px", background:C.goldLight, borderRadius:8, fontSize:12, fontWeight:700, color:C.gold, fontFamily:sans }}>{nights(hci,hco)}N</div>
                      </div>

                      {/* Rooms */}
                      <div style={{ padding:"14px 20px 18px" }}>
                        <div style={{ fontSize:12, color:C.muted, fontFamily:sans, marginBottom:12 }}>Click "Details" to view images & full amenities. Use +/− to add rooms to cart.</div>
                        {hotelRooms.map(room => {
                          const qty = cartQty(room.id, hci, hco);
                          return (
                            <div key={room.id} className="hov-card" style={{ background:C.cream, border:`1.5px solid ${qty>0?C.gold:C.border}`, borderRadius:12, padding:"14px 16px", marginBottom:10, display:"flex", gap:14, alignItems:"center", boxShadow:qty>0?`0 0 0 2px ${C.goldLight}`:"none" }}>
                              <div style={{ fontSize:26, flexShrink:0 }}>{room.img}</div>
                              <div style={{ flex:1 }}>
                                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                                  <div>
                                    <div style={{ fontSize:15, fontWeight:700, fontFamily:serif, color:C.dark }}>{room.name}</div>
                                    <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{room.view} · {room.size} · {room.available} avail</div>
                                  </div>
                                  <div style={{ textAlign:"right" }}>
                                    <div style={{ fontSize:17, fontWeight:700, fontFamily:serif, color:C.dark }}>₹{room.price.toLocaleString()}</div>
                                    <div style={{ fontSize:11, color:C.muted, fontFamily:sans }}>/night</div>
                                  </div>
                                </div>
                                <div style={{ display:"flex", flexWrap:"wrap", gap:5, margin:"8px 0" }}>
                                  {room.amenities.slice(0,4).map((a,i)=><span key={i} style={{ fontSize:10, background:C.white, border:`1px solid ${C.border}`, borderRadius:20, padding:"2px 9px", color:C.muted, fontFamily:sans }}>✓ {a}</span>)}
                                </div>
                                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                                  <button onClick={()=>setModalRoom({room,hotel})} style={{ padding:"6px 13px", border:`1.5px solid ${C.border}`, borderRadius:7, background:C.white, fontSize:12, cursor:"pointer", fontFamily:sans, fontWeight:600, color:C.dark }}>Details & Images</button>
                                  <div style={{ display:"flex", alignItems:"center", gap:8, marginLeft:"auto" }}>
                                    <button onClick={()=>addToCart(room,Math.max(0,qty-1),hotel,hci,hco)} style={{ width:28, height:28, borderRadius:"50%", border:`1.5px solid ${C.border}`, background:C.white, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center" }}>−</button>
                                    <span style={{ fontSize:16, fontWeight:700, fontFamily:sans, minWidth:22, textAlign:"center" }}>{qty}</span>
                                    <button onClick={()=>addToCart(room,Math.min(room.available,qty+1),hotel,hci,hco)} style={{ width:28, height:28, borderRadius:"50%", border:`1.5px solid ${C.border}`, background:C.white, cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center" }}>+</button>
                                    {qty>0 && <span style={{ fontSize:12, color:C.gold, fontWeight:700, fontFamily:sans }}>₹{(room.price*nights(hci,hco)*qty).toLocaleString()}</span>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Right: Cart */}
          <div style={{ width:280, flexShrink:0 }}>
            <div style={{ position:"sticky", top:80 }}>
              <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:16, overflow:"hidden" }}>
                <div style={{ background:"linear-gradient(135deg,#813626,#813626)", padding:"16px 18px", color:"#fff" }}>
                  <div style={{ fontSize:14, fontWeight:700, fontFamily:sans }}>🛒 Booking Cart</div>
                  <div style={{ fontSize:12, color:"rgba(255,255,255,0.45)", fontFamily:sans, marginTop:2 }}>{totalRooms} room{totalRooms!==1?"s":""} · {[...new Set(cart.map(i=>i.hotelId))].length} propert{[...new Set(cart.map(i=>i.hotelId))].length!==1?"ies":"y"}</div>
                </div>

                {cart.length===0 ? (
                  <div style={{ padding:"32px 18px", textAlign:"center" }}>
                    <div style={{ fontSize:32, marginBottom:10 }}>🏨</div>
                    <div style={{ fontSize:13, color:C.muted, fontFamily:sans }}>Add rooms from any hotel to get started</div>
                  </div>
                ) : (
                  <div>
                    <div style={{ maxHeight:340, overflowY:"auto" }}>
                      {cart.map(item=>(
                        <div key={item.key} style={{ padding:"12px 16px", borderBottom:`1px solid ${C.border}` }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:4 }}>
                            <div style={{ flex:1, marginRight:8 }}>
                              <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>{item.hotelImg} {item.hotelName.split(",")[0]}</div>
                              <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{item.roomImg} {item.qty}× {item.roomName}</div>
                              <div style={{ fontSize:11, color:C.muted, fontFamily:sans }}>{new Date(item.checkin).toLocaleDateString("en-IN",{day:"numeric",month:"short"})} → {new Date(item.checkout).toLocaleDateString("en-IN",{day:"numeric",month:"short"})} · {cartNights(item)}N</div>
                            </div>
                            <button onClick={()=>removeFromCart(item.key)} style={{ background:"none", border:"none", color:C.red, cursor:"pointer", fontSize:16, flexShrink:0 }}>×</button>
                          </div>
                          <div style={{ fontSize:13, fontWeight:700, color:C.gold, fontFamily:sans }}>₹{(item.qty*item.roomPrice*cartNights(item)).toLocaleString()}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ padding:"14px 16px", borderTop:`1px solid ${C.border}` }}>
                      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                        <span style={{ fontSize:13, color:C.muted, fontFamily:sans }}>Total Amount</span>
                        <span style={{ fontSize:16, fontWeight:700, fontFamily:serif, color:C.dark }}>₹{totalAmt.toLocaleString()}</span>
                      </div>
                      <div style={{ fontSize:12, color:C.green, fontFamily:sans, marginBottom:14 }}>You'll earn {pointsEarn.toLocaleString()} pts</div>
                      <button onClick={()=>{ buildSlots(); setStep(2); }}
                        style={{ width:"100%", padding:"12px", background:C.dark, color:"#fff", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:sans }}>
                        Guest Details →
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ─────── STEP 2: Guest Details ─────── */}
      {step===2 && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <div style={{ fontSize:18, fontWeight:700, fontFamily:serif, color:C.dark }}>Guest Details</div>
            <button onClick={()=>setStep(1)} style={{ fontSize:13, color:C.gold, background:"none", border:"none", cursor:"pointer", fontFamily:sans, fontWeight:700 }}>← Back to Cart</button>
          </div>

          {/* Booking type */}
          <div style={{ marginBottom:22 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.dark, fontFamily:sans, marginBottom:12 }}>How are rooms being allocated?</div>
            <div style={{ display:"flex", gap:12 }}>
              {[
                { id:"same",      icon:"👤", label:"Same Guest",       sub:"All rooms for one person" },
                { id:"bulk",      icon:"👥", label:"Group / Bulk",     sub:"One contact, group check-in" },
                { id:"different", icon:"🗂️", label:"Different Guests", sub:"Assign each room individually" },
              ].map(bt=>(
                <div key={bt.id} onClick={()=>setBookingType(bt.id)} className="hov-card"
                  style={{ flex:1, background:C.white, border:`2px solid ${bookingType===bt.id?C.gold:C.border}`, borderRadius:14, padding:16, cursor:"pointer", textAlign:"center", boxShadow:bookingType===bt.id?`0 0 0 3px ${C.goldLight}`:"none" }}>
                  <div style={{ fontSize:26, marginBottom:7 }}>{bt.icon}</div>
                  <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans, marginBottom:3 }}>{bt.label}</div>
                  <div style={{ fontSize:11, color:C.muted, fontFamily:sans }}>{bt.sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Same / Bulk */}
          {(bookingType==="same"||bookingType==="bulk") && (
            <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:16, padding:22, marginBottom:20 }}>
              <div style={{ fontSize:14, fontWeight:700, color:C.dark, fontFamily:sans, marginBottom:16 }}>{bookingType==="same"?"Guest Information":"Primary Contact"}</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <Inp label="Full Name *" value={primaryGuest.name} onChange={v=>setPrimaryGuest(p=>({...p,name:v}))} placeholder="e.g. Amit Kumar" />
                <Inp label="Email *" type="email" value={primaryGuest.email} onChange={v=>setPrimaryGuest(p=>({...p,email:v}))} placeholder="amit@company.com" />
                <Inp label="Phone *" type="tel" value={primaryGuest.phone} onChange={v=>setPrimaryGuest(p=>({...p,phone:v}))} placeholder="+91 98765 43210" />
                <Inp label="Company" value={primaryGuest.company} onChange={v=>setPrimaryGuest(p=>({...p,company:v}))} placeholder="Organisation" />
              </div>
              {bookingType==="bulk" && totalRooms>1 && (
                <div style={{ marginTop:14, padding:12, background:C.goldLight, borderRadius:9, fontSize:12, color:"#7A5C00", fontFamily:sans }}>
                  💡 This contact will be the primary booker for all {totalRooms} rooms across {[...new Set(cart.map(i=>i.hotelId))].length} properties. Individual names can be provided at check-in.
                </div>
              )}
            </div>
          )}

          {/* Different guests — per room */}
          {bookingType==="different" && (
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
                <div style={{ fontSize:14, fontWeight:700, color:C.dark, fontFamily:sans }}>Assign a Guest to Each Room</div>
                <div style={{ display:"flex", gap:10 }}>
                  <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                    <div style={{ display:"flex", gap:8 }}>
                      <input id="pgname" placeholder="Primary guest name" style={{ padding:"7px 11px", border:`1.5px solid ${C.border}`, borderRadius:8, fontSize:13, outline:"none", fontFamily:sans, width:170 }}
                        onChange={e=>setPrimaryGuest(p=>({...p,name:e.target.value}))} />
                    </div>
                  </div>
                  <button onClick={copyPrimaryToAll} style={{ padding:"7px 14px", border:`1.5px solid ${C.blue}`, borderRadius:8, background:"#fff", color:C.blue, fontSize:12, cursor:"pointer", fontFamily:sans, fontWeight:700 }}>
                    Copy to All
                  </button>
                </div>
              </div>

              {/* Group by hotel */}
              {[...new Set(slots.map(s=>s.hotelName))].map(hotelName=>{
                const hotelSlots = slots.filter(s=>s.hotelName===hotelName);
                const hotelObj = HOTELS.find(h=>h.name===hotelName);
                return (
                  <div key={hotelName} style={{ marginBottom:20 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12, paddingBottom:8, borderBottom:`1px solid ${C.border}` }}>
                      <span style={{ fontSize:20 }}>{hotelObj?.img}</span>
                      <span style={{ fontSize:15, fontWeight:700, fontFamily:serif, color:C.dark }}>{hotelName}</span>
                      <span style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{hotelSlots.length} room{hotelSlots.length>1?"s":""}</span>
                    </div>
                    {hotelSlots.map((slot, idx)=>(
                      <div key={slot.slotId} style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:10 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
                          <span style={{ fontSize:18 }}>{slot.roomImg}</span>
                          <div>
                            <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>Room {idx+1}: {slot.roomName}</div>
                            <div style={{ fontSize:11, color:C.muted, fontFamily:sans }}>{new Date(slot.checkin).toLocaleDateString("en-IN",{day:"numeric",month:"short"})} → {new Date(slot.checkout).toLocaleDateString("en-IN",{day:"numeric",month:"short"})}</div>
                          </div>
                        </div>
                        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                          <Inp label="Full Name *" value={slot.name} onChange={v=>updateSlot(slot.slotId,"name",v)} placeholder="Guest name" />
                          <Inp label="Email" type="email" value={slot.email} onChange={v=>updateSlot(slot.slotId,"email",v)} placeholder="Email" />
                          <Inp label="Phone *" type="tel" value={slot.phone} onChange={v=>updateSlot(slot.slotId,"phone",v)} placeholder="Phone" />
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          )}

          {bookingType && (
            <button onClick={()=>setStep(3)}
              disabled={(bookingType==="same"||bookingType==="bulk")?(!primaryGuest.name||!primaryGuest.phone):slots.some(s=>!s.name||!s.phone)}
              style={{ width:"100%", padding:14, background:C.dark, color:"#fff", border:"none", borderRadius:12, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:sans, marginTop:8, opacity:((bookingType==="same"||bookingType==="bulk")&&(!primaryGuest.name||!primaryGuest.phone))||( bookingType==="different"&&slots.some(s=>!s.name||!s.phone))?0.45:1 }}>
              Review Booking →
            </button>
          )}
        </div>
      )}

      {/* ─────── STEP 3: Confirm ─────── */}
      {step===3 && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <div style={{ fontSize:18, fontWeight:700, fontFamily:serif, color:C.dark }}>Review & Confirm</div>
            <button onClick={()=>setStep(2)} style={{ fontSize:13, color:C.gold, background:"none", border:"none", cursor:"pointer", fontFamily:sans, fontWeight:700 }}>← Edit Guests</button>
          </div>

          {/* Group by hotel */}
          {[...new Set(cart.map(i=>i.hotelId))].map(hid=>{
            const hotelCart = cart.filter(i=>i.hotelId===hid);
            const hotelObj  = HOTELS.find(h=>h.id===hid);
            const hotelTotal= hotelCart.reduce((s,i)=>s+i.qty*i.roomPrice*cartNights(i),0);
            return (
              <div key={hid} style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:16, marginBottom:14, overflow:"hidden" }}>
                <div style={{ background:"linear-gradient(135deg,#813626,#813626)", padding:"14px 20px", color:"#fff", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700, fontFamily:serif }}>{hotelObj?.img} {hotelObj?.name}</div>
                    <div style={{ fontSize:12, color:"rgba(255,255,255,0.45)", fontFamily:sans }}>{hotelCart[0]?.checkin} → {hotelCart[0]?.checkout}</div>
                  </div>
                  <div style={{ fontSize:15, fontWeight:700, color:C.gold, fontFamily:serif }}>₹{hotelTotal.toLocaleString()}</div>
                </div>
                <div style={{ padding:"12px 20px" }}>
                  {hotelCart.map((item,i)=>(
                    <div key={item.key} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:i<hotelCart.length-1?`1px solid ${C.border}`:"none" }}>
                      <span style={{ fontSize:13, fontFamily:sans, color:C.text }}>{item.roomImg} {item.qty}× {item.roomName} · {cartNights(item)}N</span>
                      <span style={{ fontSize:13, fontWeight:700, fontFamily:sans, color:C.dark }}>₹{(item.qty*item.roomPrice*cartNights(item)).toLocaleString()}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

          {/* Guest summary */}
          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:16, padding:20, marginBottom:14 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.dark, fontFamily:sans, marginBottom:12 }}>Guest Summary</div>
            {bookingType!=="different" ? (
              <div style={{ fontSize:13, fontFamily:sans, color:C.text, lineHeight:1.8 }}>
                <strong>{primaryGuest.name}</strong> {primaryGuest.company&&`· ${primaryGuest.company}`}<br/>
                {primaryGuest.email} · {primaryGuest.phone}<br/>
                <span style={{ color:C.muted }}>{totalRooms} room{totalRooms>1?"s":""} · {bookingType==="bulk"?"Group booking":"Single guest"}</span>
              </div>
            ) : (
              slots.map((s,i)=>(
                <div key={s.slotId} style={{ fontSize:12, fontFamily:sans, color:C.text, paddingBottom:7, marginBottom:7, borderBottom:i<slots.length-1?`1px solid ${C.border}`:"none" }}>
                  <strong>{s.hotelName.split(",")[0]} · {s.roomName}:</strong> {s.name} · {s.phone}
                </div>
              ))
            )}
          </div>

          {/* Points */}
          <div style={{ background:C.goldLight, border:`1px solid #E0C97A`, borderRadius:12, padding:16, marginBottom:18, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ fontSize:13, fontFamily:sans, color:"#7A5C00" }}>Loyalty points earned</div>
            <div style={{ fontSize:20, fontWeight:700, fontFamily:serif, color:C.gold }}>+{pointsEarn.toLocaleString()} pts</div>
          </div>

          {/* Totals */}
          <div style={{ background:C.dark, borderRadius:14, padding:"18px 22px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", fontFamily:sans }}>{totalRooms} room{totalRooms>1?"s":""} · {[...new Set(cart.map(i=>i.hotelId))].length} propert{[...new Set(cart.map(i=>i.hotelId))].length>1?"ies":"y"}</div>
              <div style={{ fontSize:26, fontWeight:700, fontFamily:serif, color:"#fff" }}>₹{totalAmt.toLocaleString()}</div>
            </div>
            <button onClick={()=>setConfirmed(true)}
              style={{ padding:"14px 28px", background:C.green, color:"#fff", border:"none", borderRadius:12, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:sans }}>
              ✓ Confirm Booking
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── TA DASHBOARD ──────────────────────────────────────────────────────────────
function TaDashboard({ user, onNav }) {
  const tierColor = t => t==="Gold"?C.gold:t==="Silver"?C.silver:C.bronze;
  return (
    <div>
      <div style={{ background:"linear-gradient(140deg,#813626 50%,#813626 100%)", borderRadius:20, padding:"30px 34px", marginBottom:26, color:"#fff", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          <div style={{ fontSize:11, color:C.gold, fontWeight:700, letterSpacing:1.8, marginBottom:10, fontFamily:sans }}>WELCOME BACK</div>
          <div style={{ fontSize:28, fontWeight:700, fontFamily:serif, marginBottom:4 }}>{user.name}</div>
          <div style={{ fontSize:13, color:"rgba(255,255,255,0.5)", fontFamily:sans, marginBottom:14 }}>{user.company} · {user.city}</div>
          <Badge cat={user.category} />
        </div>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)", fontFamily:sans, marginBottom:4 }}>Loyalty Balance</div>
          <div style={{ fontSize:48, fontWeight:700, color:C.gold, fontFamily:serif, lineHeight:1 }}>{user.points.toLocaleString()}</div>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)", fontFamily:sans, marginTop:4 }}>{user.tier} · ₹{(user.points*0.5).toLocaleString()} value</div>
        </div>
      </div>
      <div style={{ display:"flex", gap:14, marginBottom:26, flexWrap:"wrap" }}>
        <StatCard label="Bookings" value={user.bookings} sub="All time" />
        <StatCard label="Points" value={user.points.toLocaleString()} sub="Redeemable" accent={C.gold} />
        <StatCard label="Value" value={`₹${(user.points*0.5).toLocaleString()}`} sub="@ ₹0.5/pt" />
        <StatCard label="Tier" value={user.tier} sub="Next review Dec 2026" accent={tierColor(user.tier)} />
      </div>
      <div style={{ marginBottom:26 }}>
        <div style={{ fontSize:17, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:14 }}>Quick Actions</div>
        <div style={{ display:"flex", gap:14 }}>
          {[{label:"Book Hotels",icon:"🏨",tab:"booking"},{label:"Redeem Points",icon:"🎁",tab:"redeem"},{label:"History",icon:"📋",tab:"history"}].map(a=>(
            <button key={a.tab} onClick={()=>onNav(a.tab)} className="hov-card"
              style={{ flex:1, background:C.white, border:`1.5px solid ${C.border}`, borderRadius:14, padding:"20px 14px", cursor:"pointer", textAlign:"center" }}>
              <div style={{ fontSize:28, marginBottom:8 }}>{a.icon}</div>
              <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>{a.label}</div>
            </button>
          ))}
        </div>
      </div>
      <div>
        <div style={{ fontSize:17, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:14 }}>Recent Transactions</div>
        <div style={{ background:C.white, borderRadius:14, border:`1px solid ${C.border}`, overflow:"hidden" }}>
          {TRANSACTIONS.slice(0,4).map((t,i)=>(
            <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 20px", borderBottom:i<3?`1px solid ${C.border}`:"none" }}>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color:C.dark, fontFamily:sans }}>{t.desc}</div>
                <div style={{ fontSize:11, color:C.muted, marginTop:2, fontFamily:sans }}>{t.date}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:13, fontWeight:700, color:t.type==="earn"?C.green:C.red, fontFamily:sans }}>{t.points} pts</div>
                {t.amount>0&&<div style={{ fontSize:11, color:C.muted, fontFamily:sans }}>₹{t.amount.toLocaleString()}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── REDEEM ────────────────────────────────────────────────────────────────────
function RedeemModule({ user, setUser }) {
  const [amount, setAmount] = useState(500);
  const [redeemed, setRedeemed] = useState(false);
  const max = Math.min(user.points,5000);
  if (redeemed) return (
    <div style={{ textAlign:"center", padding:"60px 20px" }}>
      <div style={{ fontSize:60, marginBottom:14 }}>🎁</div>
      <div style={{ fontSize:26, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:10 }}>Points Redeemed!</div>
      <div style={{ fontSize:14, color:C.muted, fontFamily:sans, marginBottom:28 }}>{amount.toLocaleString()} pts = ₹{(amount*0.5).toLocaleString()} off your next booking</div>
      <button onClick={()=>setRedeemed(false)} style={{ padding:"12px 28px", background:C.dark, color:"#fff", border:"none", borderRadius:12, fontSize:14, cursor:"pointer", fontFamily:sans, fontWeight:700 }}>Done</button>
    </div>
  );
  return (
    <div>
      <div style={{ fontSize:22, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:22 }}>Redeem Points</div>
      <div style={{ background:"linear-gradient(135deg,#813626,#813626)", borderRadius:18, padding:28, color:"#fff", marginBottom:24, textAlign:"center" }}>
        <div style={{ fontSize:11, color:C.gold, fontWeight:700, letterSpacing:2, marginBottom:8, fontFamily:sans }}>YOUR BALANCE</div>
        <div style={{ fontSize:50, fontWeight:700, fontFamily:serif, color:C.gold }}>{user.points.toLocaleString()}</div>
        <div style={{ fontSize:13, color:"rgba(255,255,255,0.4)", fontFamily:sans }}>points · worth ₹{(user.points*0.5).toLocaleString()}</div>
      </div>
      <div style={{ background:C.white, borderRadius:14, border:`1px solid ${C.border}`, padding:28, marginBottom:14 }}>
        <div style={{ fontSize:14, fontWeight:700, color:C.dark, marginBottom:18, fontFamily:sans }}>How many points to redeem?</div>
        <input type="range" min={100} max={max} step={100} value={amount} onChange={e=>setAmount(Number(e.target.value))} style={{ marginBottom:18 }} />
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontSize:30, fontWeight:700, fontFamily:serif, color:C.dark }}>{amount.toLocaleString()} pts</div>
            <div style={{ fontSize:13, color:C.green, fontFamily:sans }}>= ₹{(amount*0.5).toLocaleString()} discount</div>
          </div>
          <button onClick={()=>{ setUser(p=>({...p,points:p.points-amount})); setRedeemed(true); }}
            style={{ padding:"14px 24px", background:C.gold, color:C.dark, border:"none", borderRadius:11, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:sans }}>
            Redeem →
          </button>
        </div>
      </div>
      <div style={{ background:C.goldLight, borderRadius:11, padding:13, fontSize:12, color:"#7A5C00", fontFamily:sans }}>💡 Min 100 pts · 1 pt = ₹0.50 · Applied as discount at checkout</div>
    </div>
  );
}

// ── HISTORY ───────────────────────────────────────────────────────────────────
function HistoryModule() {
  return (
    <div>
      <div style={{ fontSize:22, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:22 }}>Transaction History</div>
      <div style={{ background:C.white, borderRadius:14, border:`1px solid ${C.border}`, overflow:"hidden" }}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 2.5fr 1fr 0.8fr", padding:"11px 20px", background:C.bg, borderBottom:`1px solid ${C.border}` }}>
          {["Date","Description","Amount","Points"].map(h=><div key={h} style={{ fontSize:10, fontWeight:700, letterSpacing:1, color:C.muted, fontFamily:sans, textTransform:"uppercase" }}>{h}</div>)}
        </div>
        {TRANSACTIONS.map((t,i)=>(
          <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 2.5fr 1fr 0.8fr", padding:"14px 20px", borderBottom:i<TRANSACTIONS.length-1?`1px solid ${C.border}`:"none", alignItems:"center" }}>
            <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{t.date}</div>
            <div style={{ fontSize:13, fontWeight:600, color:C.dark, fontFamily:sans }}>{t.desc}</div>
            <div style={{ fontSize:13, fontWeight:600, color:t.amount>0?C.dark:C.red, fontFamily:sans }}>{t.amount>0?`₹${t.amount.toLocaleString()}`:`−₹${Math.abs(t.amount).toLocaleString()}`}</div>
            <div style={{ fontSize:13, fontWeight:700, color:t.type==="earn"?C.green:C.red, fontFamily:sans }}>{t.points}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── HOTEL SALES DASHBOARD ─────────────────────────────────────────────────────
function HotelDashboard() {
  const [filter, setFilter] = useState("All");
  const filtered = filter==="All"?TA_DATA:TA_DATA.filter(t=>t.cat===filter||t.status===filter);
  const active  = TA_DATA.filter(t=>t.status==="Active").length;
  const dormant = TA_DATA.filter(t=>t.status==="Dormant").length;
  const totalRev= TA_DATA.reduce((s,t)=>s+t.revenue,0);
  return (
    <div>
      <div style={{ fontSize:22, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:4 }}>TA & Corporate Intelligence</div>
      <div style={{ fontSize:13, color:C.muted, fontFamily:sans, marginBottom:22 }}>Know who's booking, who's dormant, and who needs a visit</div>
      <div style={{ display:"flex", gap:14, marginBottom:24, flexWrap:"wrap" }}>
        <StatCard label="Total Partners" value={TA_DATA.length} sub="Registered" />
        <StatCard label="Active" value={active} sub="This month" accent={C.green} />
        <StatCard label="Dormant" value={dormant} sub="Need follow-up" accent={C.red} />
        <StatCard label="Revenue" value={`₹${(totalRev/100000).toFixed(1)}L`} sub="This quarter" accent={C.gold} />
      </div>
      <div style={{ display:"flex", gap:8, marginBottom:18, flexWrap:"wrap" }}>
        {["All","A","B","C","Active","Dormant"].map(f=>(
          <button key={f} onClick={()=>setFilter(f)}
            style={{ padding:"7px 16px", borderRadius:20, border:`1.5px solid ${filter===f?C.dark:C.border}`, background:filter===f?C.dark:"#fff", color:filter===f?"#fff":C.text, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:sans }}>
            {f==="A"?"Cat A":f==="B"?"Cat B":f==="C"?"Cat C":f}
          </button>
        ))}
      </div>
      <div style={{ background:C.white, borderRadius:14, border:`1px solid ${C.border}`, overflow:"hidden" }}>
        <div style={{ display:"grid", gridTemplateColumns:"1.5fr 1.5fr 0.6fr 0.8fr 1fr 1fr 0.9fr", padding:"11px 18px", background:C.bg, borderBottom:`1px solid ${C.border}` }}>
          {["Partner","Company","Cat","City","Revenue","Points","Action"].map(h=><div key={h} style={{ fontSize:10, fontWeight:700, letterSpacing:1, color:C.muted, fontFamily:sans, textTransform:"uppercase" }}>{h}</div>)}
        </div>
        {filtered.map((t,i)=>(
          <div key={t.id} style={{ display:"grid", gridTemplateColumns:"1.5fr 1.5fr 0.6fr 0.8fr 1fr 1fr 0.9fr", padding:"14px 18px", borderBottom:i<filtered.length-1?`1px solid ${C.border}`:"none", alignItems:"center" }}>
            <div>
              <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>{t.name}</div>
              <div style={{ fontSize:11, color:t.status==="Active"?C.green:C.red, fontFamily:sans, fontWeight:600 }}>{t.status} {t.trend==="up"?"↑":t.trend==="down"?"↓":"→"}</div>
            </div>
            <div style={{ fontSize:12, color:C.text, fontFamily:sans }}>{t.company}</div>
            <Badge cat={t.cat} />
            <div style={{ fontSize:12, color:C.muted, fontFamily:sans }}>{t.city}</div>
            <div style={{ fontSize:13, fontWeight:700, color:C.dark, fontFamily:sans }}>₹{t.revenue.toLocaleString()}</div>
            <div style={{ fontSize:12, color:C.gold, fontWeight:700, fontFamily:sans }}>{t.points.toLocaleString()} pts</div>
            <button style={{ padding:"6px 11px", border:`1.5px solid ${t.status==="Dormant"?C.red:C.border}`, borderRadius:7, background:"#fff", color:t.status==="Dormant"?C.red:C.text, fontSize:11, cursor:"pointer", fontFamily:sans, fontWeight:600 }}>
              {t.status==="Dormant"?"Follow Up":"View"}
            </button>
          </div>
        ))}
      </div>
      <div style={{ marginTop:14, padding:14, background:"#FDECEA", borderRadius:11, fontSize:12, color:"#7B241C", fontFamily:sans }}>
        🚨 <strong>{dormant} dormant partners</strong> haven't booked in 45+ days — flag for sales outreach before they shift to OTA channels.
      </div>
    </div>
  );
}

// ── LOGIN ─────────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [uid,setUid]=useState(""); const [pw,setPw]=useState(""); const [err,setErr]=useState(""); const [loading,setLoading]=useState(false);
  const handle=()=>{ setErr(""); setLoading(true); setTimeout(()=>{ const u=USERS[uid.trim().toLowerCase()]; if(u&&u.password===pw) onLogin({...u,id:uid}); else setErr("Invalid credentials."); setLoading(false); },700); };
  return (
    <div style={{ minHeight:"100vh", background:C.bg, display:"flex", fontFamily:sans }}>
      <div style={{ width:"42%", background:"linear-gradient(160deg,#813626 55%,#813626 100%)", display:"flex", flexDirection:"column", justifyContent:"space-between", padding:"46px 50px", color:"#fff" }}>
        <div>
          <div style={{ fontSize:11, fontWeight:700, letterSpacing:3, color:C.gold, marginBottom:18 }}>CIN UNIVERSE</div>
          <div style={{ fontSize:38, fontWeight:700, fontFamily:serif, lineHeight:1.25, marginBottom:12 }}>B2B Partner<br/>Loyalty Portal</div>
          <div style={{ fontSize:14, color:"rgba(255,255,255,0.45)", lineHeight:1.7, fontStyle:"italic" }}>For Travel Agents & Corporate Bookers</div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          {["Book across multiple properties in one session","Earn points on every direct booking","Redeem within IBE — no third-party redirects","Assign rooms individually to different guests","Hotel sales intelligence — track every TA"].map((f,i)=>(
            <div key={i} style={{ display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ width:6, height:6, borderRadius:"50%", background:C.gold, flexShrink:0 }}/>
              <span style={{ fontSize:13, color:"rgba(255,255,255,0.65)" }}>{f}</span>
            </div>
          ))}
          <div style={{ marginTop:10, paddingTop:16, borderTop:"1px solid rgba(255,255,255,0.07)", fontSize:11, color:"rgba(255,255,255,0.2)" }}>Powered by CIN Universe · Direct Revenue Ecosystem</div>
        </div>
      </div>
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:48 }}>
        <div style={{ width:"100%", maxWidth:390 }}>
          <div style={{ fontSize:28, fontWeight:700, fontFamily:serif, color:C.dark, marginBottom:5 }}>Welcome Back</div>
          <div style={{ fontSize:14, color:C.muted, marginBottom:30 }}>Sign in to your partner account</div>
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:10, fontWeight:700, letterSpacing:0.9, color:C.muted, display:"block", marginBottom:7, textTransform:"uppercase" }}>Partner ID</label>
            <input value={uid} onChange={e=>setUid(e.target.value)} placeholder="e.g. ta001 or corp001" style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${C.border}`, borderRadius:10, fontSize:14, outline:"none", background:C.white, fontFamily:sans }} />
          </div>
          <div style={{ marginBottom:10 }}>
            <label style={{ fontSize:10, fontWeight:700, letterSpacing:0.9, color:C.muted, display:"block", marginBottom:7, textTransform:"uppercase" }}>Password</label>
            <input type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="••••••••" style={{ width:"100%", padding:"12px 14px", border:`1.5px solid ${C.border}`, borderRadius:10, fontSize:14, outline:"none", background:C.white, fontFamily:sans }} />
          </div>
          {err&&<div style={{ color:C.red, fontSize:12, marginBottom:8 }}>{err}</div>}

          {/* <div style={{ margin:"10px 0 20px", padding:13, background:C.cream, borderRadius:9, fontSize:11, color:C.muted, lineHeight:1.9 }}>
            <strong>Demo Credentials:</strong><br/>sharma.travels / ST@2026 · Cat A Gold<br/>infosys.corp / INF@2026 · Cat B Silver<br/>verma.tours / VT@2026 · Cat C Bronze
          </div> */}

          <button onClick={handle} disabled={loading} style={{ width:"100%", padding:14, background:C.dark, color:"#fff", border:"none", borderRadius:11, fontSize:15, fontWeight:700, cursor:"pointer", opacity:loading?0.7:1 }}>
            {loading?"Signing in…":"Sign In →"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── APP SHELL ─────────────────────────────────────────────────────────────────
export default function B2BPortal() {
  const [user,setUser]=useState(null);
  const [view,setView]=useState("ta");
  const [activeTab,setActiveTab]=useState("dashboard");
  if (!user) return (<><FontImport/><LoginScreen onLogin={u=>{ setUser(u); setActiveTab("dashboard"); setView("ta"); }}/></>);
  const taTabs=[{id:"dashboard",label:"Dashboard",icon:"◈"},{id:"booking",label:"Book Hotels",icon:"🏨"},{id:"redeem",label:"Redeem",icon:"🎁"},{id:"history",label:"History",icon:"📋"}];
  return (
    <>
      <FontImport/>
      <div style={{ minHeight:"100vh", background:C.bg, fontFamily:sans }}>
        <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"0 34px", display:"flex", justifyContent:"space-between", alignItems:"center", height:60, position:"sticky", top:0, zIndex:200 }}>
          <div style={{ display:"flex", alignItems:"center", gap:26 }}>
            <div style={{ fontFamily:serif, fontWeight:800, fontSize:19, color:C.dark }}>CIN <span style={{color:C.gold}}>B2B</span></div>
            <div style={{ display:"flex", background:C.bg, borderRadius:9, padding:3 }}>
              <button onClick={()=>{ setView("ta"); setActiveTab("dashboard"); }} className="tab-btn" style={{ padding:"6px 14px", borderRadius:7, border:"none", background:view==="ta"?C.dark:"transparent", color:view==="ta"?"#fff":C.muted, fontSize:12, fontWeight:700, cursor:"pointer" }}>Partner View</button>
              <button onClick={()=>setView("hotel")} className="tab-btn" style={{ padding:"6px 14px", borderRadius:7, border:"none", background:view==="hotel"?C.dark:"transparent", color:view==="hotel"?"#fff":C.muted, fontSize:12, fontWeight:700, cursor:"pointer" }}>Hotel View</button>
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:14 }}>
            {view==="ta"&&<div style={{ fontSize:13, color:C.gold, fontWeight:700 }}>{user.points.toLocaleString()} pts</div>}
            <div style={{ fontSize:13, color:C.text }}>{user.name}</div>
            <button onClick={()=>setUser(null)} style={{ padding:"6px 14px", border:`1.5px solid ${C.border}`, borderRadius:7, background:"#fff", fontSize:12, cursor:"pointer", color:C.text }}>Sign Out</button>
          </div>
        </div>
        <div style={{ display:"flex", maxWidth:1240, margin:"0 auto", padding:"26px 34px", gap:26 }}>
          {view==="ta"&&(
            <div style={{ width:188, flexShrink:0 }}>
              <div style={{ background:C.white, borderRadius:14, border:`1px solid ${C.border}`, overflow:"hidden" }}>
                {taTabs.map((t,i)=>(
                  <button key={t.id} onClick={()=>setActiveTab(t.id)} className="tab-btn"
                    style={{ width:"100%", textAlign:"left", padding:"14px 16px", border:"none", background:activeTab===t.id?C.goldLight:"transparent", color:activeTab===t.id?C.gold:C.text, fontSize:13, fontWeight:activeTab===t.id?700:500, cursor:"pointer", display:"flex", alignItems:"center", gap:9, borderBottom:i<taTabs.length-1?`1px solid ${C.border}`:"none" }}>
                    <span>{t.icon}</span>{t.label}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div style={{ flex:1, minWidth:0 }}>
            {view==="hotel"?<HotelDashboard/>:(
              <>
                {activeTab==="dashboard"&&<TaDashboard user={user} onNav={setActiveTab}/>}
                {activeTab==="booking"&&<BookingModule user={user}/>}
                {activeTab==="redeem"&&<RedeemModule user={user} setUser={setUser}/>}
                {activeTab==="history"&&<HistoryModule/>}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}